import React, { useMemo } from 'react'
import useToggle from 'hooks/useToggle'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import LuxPlusInclusions from 'luxPlus/components/LuxPlusInclusions'
import Group from 'components/utils/Group'
import InclusionsSection from '../FlashHotel/InclusionsSection'
import TextLink from 'components/Luxkit/TextLink'
import { useOfferInclusions } from 'hooks/useOfferInclusions'
import { take } from 'lib/array/arrayUtils'
import moment from 'moment'
import { getInclusionsViewableLuxPlusTier } from 'selectors/luxPlusSelectors'

interface MappedProps {
  checkIn?: string;
  duration?: number;
  inclusionsViewableLuxPlusTier: App.MembershipSubscriptionTier;
}

interface Props extends MappedProps {
  offer: App.Offer;
  packageOption: OfferPackageOptionView;
}

const NUM_INCLUSIONS_TO_SHOW = 3

function MultipleRoomsBookingOption(props: Props) {
  const {
    offer,
    checkIn,
    duration,
    packageOption,
  } = props

  const pkg = packageOption.package

  const [showMoreInclusion, onToggleInclusions] = useToggle()

  const checkInMoment = useMemo(() => checkIn ? moment(checkIn) : undefined, [checkIn])
  const checkOutMoment = useMemo(() => checkInMoment?.clone().add(duration, 'days'), [checkInMoment, duration])

  const { inclusions, bonusInclusions, luxPlusInclusions } = useOfferInclusions(pkg, { checkIn: checkInMoment, checkOut: checkOutMoment })

  const totalInclusionsCount = inclusions.length + bonusInclusions.length

  return (
    <Group direction="vertical" gap={8}>
      {!!luxPlusInclusions?.length && <LuxPlusInclusions
        luxPlusInclusions={luxPlusInclusions}
        accommodationOffer={offer}
      />}
      <InclusionsSection
        inclusions={take(inclusions, showMoreInclusion ? inclusions.length : NUM_INCLUSIONS_TO_SHOW)}
        bonusInclusions={bonusInclusions}
      />
      {totalInclusionsCount > NUM_INCLUSIONS_TO_SHOW &&
        <TextLink size="medium" weight="bold" onClick={onToggleInclusions}>
          {showMoreInclusion ? 'View less inclusions' : `+ ${totalInclusionsCount - NUM_INCLUSIONS_TO_SHOW} more inclusions`}
        </TextLink>
      }
    </Group>
  )
}

export default withOfferPageAndReduxState((state, appState): MappedProps => ({
  checkIn: state.checkInDate,
  duration: state.duration,
  inclusionsViewableLuxPlusTier: getInclusionsViewableLuxPlusTier(appState),
}))(MultipleRoomsBookingOption)
